export default __webpack_public_path__ + "static/media/admin-ols-user.b422b39b.jpg";